import React, {Component} from 'react'
import {Button, Form, Row, Col, Input, Spin, Space, Tooltip, Switch} from 'antd'
import {SearchOutlined, QuestionCircleFilled} from '@ant-design/icons'
import UPM from '../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'
const storage = window.localStorage

@inject('accountStore', 'themeSettingStore')
@observer
class themeSetting extends Component {
  formRef = React.createRef()

  handleSave = () => {
    const {themeSettingStore} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      themeSettingStore.onSaveAction({configData: JSON.stringify(fieldsValue)})
    }).catch()
  }

  componentDidMount() {
    const {accountStore} = this.props
    accountStore.onGetThemeStyle().then(res=> {
      console.log(res)
      if(res && res.data && res.data.code === 0) {
        const configData = JSON.parse(res.data.data?.configData || '{}')
        this.formRef.current.setFieldsValue(configData)
      }
    })
  }


  render() {
    const {accountStore, location, t, themeSettingStore} = this.props
    const {isFetching} = themeSettingStore
    const {themeStyle} = accountStore
    const formItemLayout = {
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 16,
      },
    };
    const formList = [{
      title: t(`themeSetting.publicTitle`),
      name: 'publicTitle',
      tips: t(`themeSetting.publicTitleTips`),
      type: 'string'
    },{
      title: t(`themeSetting.iconImage`),
      name: 'iconImage',
      tips: t(`themeSetting.iconImageTips`),
      type: 'string'
    },{
      title: t(`themeSetting.loginBackground`),
      name: 'loginBackground',
      tips: t(`themeSetting.loginBackgroundTips`),
      type: 'string'
    },{
      title: t(`themeSetting.loginLogoImage`),
      name: 'loginLogoImage',
      tips: t(`themeSetting.loginLogoImageTips`),
      type: 'string'
    },{
      title: t(`themeSetting.loginTitle`),
      name: 'loginTitle',
      tips: t(`themeSetting.loginTitleTips`),
      type: 'string'
    },{
      title: t(`themeSetting.loginSubTitle`),
      name: 'loginSubTitle',
      tips: t(`themeSetting.loginSubTitleTips`),
      type: 'string'
    },{
      title: t(`themeSetting.loginIsColumn`),
      name: 'loginIsColumn',
      tips: t(`themeSetting.loginIsColumnTips`),
      type: 'boolean'
    },{
      title: t(`themeSetting.menuBackgroundImage`),
      name: 'menuBackgroundImage',
      tips: t(`themeSetting.menuBackgroundImageTips`),
      type: 'string'
    },{
      title: t(`themeSetting.menuBackgroundColor`),
      name: 'menuBackgroundColor',
      tips: t(`themeSetting.menuBackgroundColorTips`),
      type: 'string'
    },{
      title: t(`themeSetting.menuItemBackgroundColor`),
      name: 'menuItemBackgroundColor',
      tips: t(`themeSetting.menuItemBackgroundColorTips`),
      type: 'string'
    },{
      title: t(`themeSetting.logoImage`),
      name: 'logoImage',
      tips: t(`themeSetting.logoImageTips`),
      type: 'string'
    },{
      title: t(`themeSetting.logoImageCollapsed`),
      name: 'logoImageCollapsed',
      tips: t(`themeSetting.logoImageCollapsedTips`),
      type: 'string'
    },{
      title: t(`themeSetting.primaryColor`),
      name: 'primaryColor',
      tips: t(`themeSetting.primaryColorTips`),
      type: 'string'
    },{
      title: t(`themeSetting.primaryHoverColor`),
      name: 'primaryHoverColor',
      tips: t(`themeSetting.primaryHoverColorTips`),
      type: 'string'
    },{
      title: t(`themeSetting.dangerColor`),
      name: 'dangerColor',
      tips: t(`themeSetting.dangerColorTips`),
      type: 'string'
    },{
      title: t(`themeSetting.dangerHoverColor`),
      name: 'dangerHoverColor',
      tips: t(`themeSetting.dangerHoverColorTips`),
      type: 'string'
    },{
      title: t(`themeSetting.buttonBorderRadius`),
      name: 'buttonBorderRadius',
      tips: t(`themeSetting.buttonBorderRadiusTips`),
      type: 'string'
    },{
      title: t(`themeSetting.statusColor`),
      name: 'statusColor',
      tips: t(`themeSetting.statusColorTips`),
      type: 'string'
    },{
      title: t(`themeSetting.tableThHeight`),
      name: 'tableThHeight',
      tips: t(`themeSetting.tableThHeightTips`),
      type: 'string'
    },{
      title: t(`themeSetting.tableTrHeight`),
      name: 'tableTrHeight',
      tips: t(`themeSetting.tableTrHeightTips`),
      type: 'string'
    },{
      title: t(`themeSetting.tableTrLineHeight`),
      name: 'tableTrLineHeight',
      tips: t(`themeSetting.tableTrLineHeightTips`),
      type: 'string'
    },{
      title: t(`themeSetting.tableTdPadding`),
      name: 'tableTdPadding',
      tips: t(`themeSetting.tableTdPaddingTips`),
      type: 'string'
    },{
      title: t(`themeSetting.tableTrBorder`),
      name: 'tableTrBorder',
      tips: t(`themeSetting.tableTrBorderTips`),
      type: 'string'
    },{
      title: t(`themeSetting.tableOddRowBg`),
      name: 'tableOddRowBg',
      tips: t(`themeSetting.tableOddRowBgTips`),
      type: 'string'
    },{
      title: t(`themeSetting.tableEvenRowBg`),
      name: 'tableEvenRowBg',
      tips: t(`themeSetting.tableEvenRowBgTips`),
      type: 'string'
    },{
      title: t(`themeSetting.tableRowHoverBg`),
      name: 'tableRowHoverBg',
      tips: t(`themeSetting.tableRowHoverBgTips`),
      type: 'string'
    },{
      title: t(`themeSetting.layoutHorizontal`),
      name: 'layoutHorizontal',
      tips: t(`themeSetting.layoutHorizontalTips`),
      type: 'boolean'
    },{
      title: t(`themeSetting.formItemLabelHeight`),
      name: 'formItemLabelHeight',
      tips: t(`themeSetting.formItemLabelHeightTips`),
      type: 'string'
    }]

    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <Form ref={this.formRef} size="middle" className="searchForm" {...formItemLayout}>
            <div className="searchFormTitle">
              <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
            </div>
            <Row gutter={[10, 0]}>
              {formList.map(item=> {
                return (<Col span={12}>
                  <Form.Item label={item.title}>
                    <Space>
                      {item.type === 'string' ? 
                        <Form.Item name={item.name} style={{width: 400, marginBottom: 0}}
                          rules={[{
                            message: `${t(`general.pleaseEnter`)} ${item.title} ${t(`general.withoutSpecialChats`)}`,
                            pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                          }]}>
                          <Input placeholder={t(`general.pleaseEnter`)} allowClear/>
                        </Form.Item> : 
                          <Form.Item name={item.name} valuePropName="checked" style={{width: 400, marginBottom: 0}}
                            rules={[{
                              message: `${t(`general.pleaseEnter`)} ${item.title} ${t(`general.withoutSpecialChats`)}`,
                              pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                            }]}>
                          <Switch />
                        </Form.Item>}
                      <Tooltip title={item.tips}>
                        <QuestionCircleFilled />
                      </Tooltip>
                    </Space>
                  </Form.Item>
                </Col>)
              })}
              <Col span={24} style={{ textAlign: 'center', margin: '10px 0 30px'}}>
                <Button onClick={() => { this.handleSave() }} className="ant-btn-red">{t(`general.save`)}</Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Spin>
    )
  }
}

export default withTranslation()(themeSetting)
